// extracted by mini-css-extract-plugin
export default {"user_image":"user-image_user_image__MaSxK"};